export default {
	arabic: 'Arabe',
	english: 'Anglais',
	french: 'Français',
	japanese: 'Japonais',
	language: 'Langue',
	spanish: 'Espanol',

	cairo: 'El Caire',
	london: 'Londres',
	mexicoCity: 'Mexico',

	multipleLocales: 'Plusieurs langues'
};
